import $api from "../http";
import { ILegalPageListItem, LegalPageKey, LegalPageLanguageType } from "../models/LegalPage";

class LegalPageServiceClass {
  async getAll() {
    return $api.get<ILegalPageListItem[]>("api/legal-pages");
  }

  async getContent(key: LegalPageKey, language: LegalPageLanguageType) {
    return $api.get<{ content: string | null }>(`api/legal-pages/${key}/${language}`);
  }

  async save(key: LegalPageKey, language: LegalPageLanguageType, content: string) {
    return $api.put<{}>(`api/legal-pages/${key}/${language}`, { content });
  }
}

export const LegalPageService = new LegalPageServiceClass();
